import { captureException, captureMessage } from '@sentry/nextjs'
import { type ScopeContext, type SeverityLevel } from '@sentry/types'

export const sendToLogger = (
  err: unknown,
  errorContext?: Partial<ScopeContext>,
  logLevel: SeverityLevel = 'error'
) => {
  // Log error to console in development mode for easier debugging
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(err)
  }

  const fingerprint: string[] = errorContext?.fingerprint || []
  if (err && err instanceof Error) {
    fingerprint.push(err.name)
    fingerprint.push(err.message)
  } else if (err && typeof err === 'string') {
    fingerprint.push(err)
  }

  return captureException(err, {
    ...(errorContext && errorContext),
    level: logLevel,
    fingerprint,
  })
}

export const logger = {
  captureMessage: (message: string, captureContext: Partial<ScopeContext> | SeverityLevel) =>
    captureMessage(message, captureContext),
}

export const cleanupErrorForSentry = (error: Error, name?: string) => {
  const cleanedUpError = new Error()
  cleanedUpError.message = error.message
  cleanedUpError.name = name ?? error.name
  cleanedUpError.stack = error.stack
  return cleanedUpError
}
